import React from 'react';
import { Link } from 'react-router-dom';
import { formatTimeAgo, formatXPUNT } from '../../utils/helpers';
import { FaUsers, FaClock, FaTrophy, FaLock, FaUnlock } from 'react-icons/fa';
import './CompetitionCard.css';

const CompetitionCard = ({ competition }) => {
  const {
    id,
    title,
    description,
    status,
    is_free,
    join_price,
    players_count,
    total_prize_pool,
    created_at,
    visibility,
  } = competition;

  const getStatusBadge = () => {
    const badges = {
      open: { label: 'Open', className: 'status-open' },
      ended: { label: 'Ended', className: 'status-ended' },
      upcoming: { label: 'Upcoming', className: 'status-upcoming' },
      full: { label: 'Full', className: 'status-full' },
    };
    return badges[status] || badges.open;
  };

  const statusBadge = getStatusBadge();

  return (
    <Link to={`/competitions/${id}`} className="competition-card">
      <div className="competition-card-header">
        <div className="competition-card-meta">
          <span className={`competition-status ${statusBadge.className}`}>
            {statusBadge.label}
          </span>
          {visibility === 'private' && (
            <span className="competition-private">
              <FaLock /> Private
            </span>
          )}
          {visibility === 'public' && (
            <span className="competition-public">
              <FaUnlock /> Public
            </span>
          )}
        </div>
        <div className="competition-card-price">
          {is_free ? (
            <span className="free-badge">Free Entry</span>
          ) : (
            <span className="price-badge">{formatXPUNT(join_price)}</span>
          )}
        </div>
      </div>

      <div className="competition-card-body">
        <h3 className="competition-card-title">{title}</h3>
        {description && (
          <p className="competition-card-description">
            {description.length > 100 
              ? `${description.substring(0, 100)}...` 
              : description}
          </p>
        )}
      </div>

      <div className="competition-card-footer">
        <div className="competition-card-stats">
          <div className="stat">
            <FaUsers className="stat-icon" />
            <span>{players_count || 0} Players</span>
          </div>
          <div className="stat">
            <FaTrophy className="stat-icon" />
            <span>{formatXPUNT(total_prize_pool || 0)}</span>
          </div>
          <div className="stat">
            <FaClock className="stat-icon" />
            <span>{formatTimeAgo(created_at)}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CompetitionCard;